import {
  AddConsumerForm,
  ConsumersTable,
  Section,
} from '@/components/molecules'
import { TestConsumer } from '@/components/organisms'
import { useAddConsumer, useRemoveConsumer } from '@/hooks'
import { useEffect, useState } from 'react'

export const ManageConsumers = ({
  subId,
  refetchSub,
  consumers,
  isLoading,
}) => {
  const [showAddConsumer, setShowAddConsumer] = useState(false)
  const [showTestConsumer, setShowTestConsumer] = useState(false)
  const [testConsumerAddress, setTestConsumerAddress] = useState(false)
  const { submit: submitAddConsumer, isSuccess: isSuccessAddConsumer } =
    useAddConsumer()
  const { submit: submitRemoveConsumer, isSuccess: isSuccessRemoveConsumer } =
    useRemoveConsumer()

  const handleAddConsumer = () => {
    setShowAddConsumer(true)
  }

  const onAddConsumerSubmit = ({ address: consumerAddress }) => {
    if (!consumerAddress || !subId) return

    submitAddConsumer({ subId, consumerAddress })
  }

  const handleConsumerDelete = ({ consumerAddress }) => {
    if (!consumerAddress || !subId) return

    submitRemoveConsumer({ subId, consumerAddress })
  }

  const handleConsumerTest = ({ consumerAddress }) => {
    setShowTestConsumer(true)
    setTestConsumerAddress(consumerAddress)
  }

  useEffect(() => {
    if (isSuccessAddConsumer || isSuccessRemoveConsumer) {
      refetchSub()
    }
  }, [isSuccessAddConsumer, isSuccessRemoveConsumer, refetchSub])

  return (
    <>
      <Section
        alignItems={'stretch'}
        title="Consumers"
        action={{ text: 'Add Consumer', action: handleAddConsumer }}
        isLoading={isLoading}
      >
        {showAddConsumer && (
          <AddConsumerForm
            onSubmit={onAddConsumerSubmit}
            setShowAddConsumer={setShowAddConsumer}
          />
        )}

        <ConsumersTable
          consumers={consumers}
          isLoading={isLoading}
          onConsumerDelete={handleConsumerDelete}
          onConsumerTest={handleConsumerTest}
        />
      </Section>

      {showTestConsumer && (
        <TestConsumer consumerAddress={testConsumerAddress} subId={subId} />
      )}
    </>
  )
}
